/**
 * Created by r4zi4l on 13.01.2021
 */

const UnitsLibraryWindow = CleverappsWindow.extend({ 
    onWindowLoaded: function (unit) {
        this.searchUnit = unit;

        const styles = cleverapps.styles.UnitsLibraryWindow;

        this.tabsInfo = this.createTabs();

        this.resolutionMode = cleverapps.resolution.mode;

        this._super({
            name: "UnitsLibraryWindow",
            title: styles.withTitle ? Messages.get("UnitsLibraryWindow.title") : undefined,
            content: this.createContent(),
            noPadding: true,
            styles: cleverapps.styles.UnitsLibraryWindow.window,
            foreground: bundles.unitslibrarywindow.frames.window_foreground_library_png || bundles.windows.frames.window_foreground_png,
            openSound: bundles.unitslibrarywindow.urls.new_unit_window_effect
        });
    },

    onShow: function () {
        this._super();

        this.activateTab();
    },

    createTabs: function () {
        const info = this.createTabsInfo();

        Object.keys(info).forEach((id) => {
            if (cleverapps.unitsLibrary.listTabCodes(cleverapps.meta.selectedLocationId(), id).length === 0) {
                delete info[id];
            }
        });

        return info;
    },

    createContent: function () {
        const styles = cleverapps.styles.UnitsLibraryWindow;

        const content = this.innerContent = new cc.Node();
        content.setAnchorPoint(0.5, 0.5);
        content.setContentSize2(styles.size);

        const contentWrapper = cleverapps.UI.wrapWithPadding(content);

        const tabs = this.tabs = new Tabs(this.tabsInfo, styles.tabs);
        tabs.setAnchorPoint(0.5, 0.5);
        tabs.setAlignment(styles.tabs.position);
        tabs.setLocalZOrder(styles.tabs.zOrder);
        contentWrapper.addChild(tabs);

        cleverapps.eventBus.on("unitStatusChanged", this.updateTabsAttentions.bind(this), this);
        this.updateTabsAttentions();

        if (styles.tabs.insideWindow) {
            cleverapps.UI.wrap(contentWrapper);
        }

        return contentWrapper;
    },

    activateTab: function () {
        let activeTab;
        let freshTab;

        for (const id in this.tabsInfo) {
            const codes = cleverapps.unitsLibrary.listTabCodes(cleverapps.meta.selectedLocationId(), id);
            if (!activeTab && this.searchUnit && codes.indexOf(this.searchUnit.code) !== -1) {
                activeTab = id;
            }
            if (!freshTab && cleverapps.unitsLibrary.hasAnyFresh(codes)) {
                freshTab = id;
            }
        }

        this.tabs.activateTab(activeTab || freshTab || Object.keys(this.tabsInfo)[0], { searchUnit: this.searchUnit });
    },

    updateTabsAttentions: function () {
        for (const id in this.tabsInfo) {
            const codes = cleverapps.unitsLibrary.listTabCodes(cleverapps.meta.selectedLocationId(), id);
            this.tabs.setAttention(id, cleverapps.unitsLibrary.hasAnyFresh(codes));
        }
    },

    createTab: function (Tab, id) {
        const styles = cleverapps.styles.UnitsLibraryWindow;
        const options = {
            width: this.innerContent.width - styles.padding.x * 2,
            height: this.innerContent.height - styles.padding.y * 2,
            resolutionMode: this.resolutionMode
        };

        const codes = cleverapps.unitsLibrary.listTabCodes(cleverapps.meta.selectedLocationId(), id);
        const content = new Tab(codes, options);
        this.innerContent.addChild(content);
        return content;
    },

    createTabsInfo: function () {
        if (cleverapps.meta.selectedLocationId() === "collections") {
            return {
                0: {
                    icon: bundles.pet_tab_icons.frames.tab_icon_regular,
                    generator: this.createTab.bind(this, UnitsTab, 0)
                },
                1: {
                    icon: bundles.pet_tab_icons.frames.tab_icon_rare,
                    generator: this.createTab.bind(this, UnitsTab, 1)
                },
                2: {
                    icon: bundles.pet_tab_icons.frames.tab_icon_legend,
                    generator: this.createTab.bind(this, UnitsTab, 2)
                },
                4: {
                    icon: bundles.windows.frames.tab_icon_fruit,
                    generator: this.createTab.bind(this, UnitsTab, 4)
                },
                6: {
                    icon: bundles.windows.frames.tab_icon_chest,
                    generator: this.createTab.bind(this, UnitsTab, 6)
                },
                7: {
                    icon: bundles.windows.frames.tab_icon_valuable,
                    generator: this.createTab.bind(this, UnitsTab, 7)
                }
            };
        }

        return {
            0: {
                icon: bundles.windows.frames.tab_icon_heroes,
                generator: this.createTab.bind(this, Map2dLocation.currentLocation.location.locationConfig.isMain ? HeroesTab : UnitsTab, 0)
            },
            1: {
                icon: bundles.windows.frames.tab_icon_resource,
                generator: this.createTab.bind(this, UnitsTab, 1)
            },
            2: {
                icon: bundles.windows.frames.tab_icon_fruit,
                generator: this.createTab.bind(this, UnitsTab, 2)
            },
            3: {
                icon: bundles.windows.frames.tab_icon_source,
                generator: this.createTab.bind(this, UnitsTab, 3)
            },
            4: {
                icon: bundles.windows.frames.tab_icon_chest,
                generator: this.createTab.bind(this, UnitsTab, 4)
            },
            5: {
                icon: bundles.windows.frames.tab_icon_valuable,
                generator: this.createTab.bind(this, UnitsTab, 5)
            }
        };
    },

    listBundles: function () {
        let bundles = ["donor_progress_window"];

        const tabIds = Object.keys(this.createTabsInfo());

        tabIds.forEach((tabId) => {
            const codes = cleverapps.unitsLibrary.listTabCodes(cleverapps.meta.selectedLocationId(), tabId);
            bundles = bundles.concat(Families.listLazyBundles(codes));
        });

        return bundles;
    }
});

cleverapps.styles.UnitsLibraryWindow = {
    size: {
        width: 2000,
        height: 1100
    },

    padding: {
        x: 60,
        y: 0
    },

    tabs: {
        position: {
            x: { align: "left", dx: -138 },
            y: { align: "top", dy: -40 }
        },
        direction: cleverapps.UI.VERTICAL,
        size: [{ height: 140 }, { height: 140 }, { height: 140 }],
        zOrder: 0
    },

    window: {
        Background: {
            image: bundles.unitslibrarywindow.frames.window_background
        }
    }
};
